// extracted by mini-css-extract-plugin
export default {"auth":"SignUp_auth__UacLF","control":"SignUp_control__-x0Pz","actions":"SignUp_actions__K8K9a","toggle":"SignUp_toggle__WHY4i"};